import { useNavigate, useSearchParams } from "react-router-dom";
import { ProductsListPage as ProductsListPageView, type ProductsListFilters } from "@/components/ProductsListPage";

export function ProductsListPage() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultFilters: ProductsListFilters = {
    name: searchParams.get("name") ?? undefined,
    type: searchParams.get("type") ?? undefined,
  };

  function handleFiltersChange(filters: ProductsListFilters) {
    const next = new URLSearchParams();
    if (filters.name) next.set("name", filters.name);
    if (filters.type) next.set("type", filters.type);
    setSearchParams(next, { replace: true });
  }

  return (
    <ProductsListPageView
      onProductClick={(id) => navigate(`/products/${id}`)}
      defaultFilters={defaultFilters}
      onFiltersChange={handleFiltersChange}
    />
  );
}
